var _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 154,
    viewBox: "0 0 188 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.445 78.633C140.445 72.787 135.706 68.047 129.859 68.047C124.013 68.047 119.273 72.787 119.273 78.633C119.273 84.48 124.013 89.219 129.859 89.219C135.706 89.219 140.445 84.479 140.445 78.633Z",
    fill: "#0CBABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.625 78.633H134.094M129.859 82.868L134.094 78.633L129.859 74.399V82.868Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_542:15778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.08 97.689H13.176C10.9669 97.689 9.176 99.4799 9.176 101.689V141.897C9.176 144.106 10.9669 145.897 13.176 145.897H44.08C46.2891 145.897 48.08 144.106 48.08 141.897V101.689C48.08 99.4799 46.2891 97.689 44.08 97.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.468 134.593H16.365C15.6642 134.593 15.096 135.161 15.096 135.861C15.096 136.562 15.6642 137.13 16.365 137.13H40.468C41.1688 137.13 41.737 136.562 41.737 135.861C41.737 135.161 41.1688 134.593 40.468 134.593Z",
    fill: "#B6BABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.468 113.449H16.365C15.6642 113.449 15.096 114.017 15.096 114.717C15.096 115.418 15.6642 115.986 16.365 115.986H40.468C41.1688 115.986 41.737 115.418 41.737 114.717C41.737 114.017 41.1688 113.449 40.468 113.449Z",
    fill: "#0CBABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.468 107.529H16.365C15.6642 107.529 15.096 108.097 15.096 108.798C15.096 109.498 15.6642 110.066 16.365 110.066H40.468C41.1688 110.066 41.737 109.498 41.737 108.798C41.737 108.097 41.1688 107.529 40.468 107.529Z",
    fill: "#B6BABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.473 118.524H16.365C15.6642 118.524 15.096 119.092 15.096 119.793C15.096 120.493 15.6642 121.061 16.365 121.061H29.473C30.1739 121.061 30.742 120.493 30.742 119.793C30.742 119.092 30.1739 118.524 29.473 118.524Z",
    fill: "#B6BABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.473 129.096H16.365C15.6642 129.096 15.096 129.664 15.096 130.365C15.096 131.065 15.6642 131.633 16.365 131.633H29.473C30.1739 131.633 30.742 131.065 30.742 130.365C30.742 129.664 30.1739 129.096 29.473 129.096Z",
    fill: "#B6BABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.468 123.598H16.365C15.6642 123.598 15.096 124.166 15.096 124.867C15.096 125.567 15.6642 126.135 16.365 126.135H40.468C41.1688 126.135 41.737 125.567 41.737 124.867C41.737 124.166 41.1688 123.598 40.468 123.598Z",
    fill: "#B6BABF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_542:15778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.05 4H10C7.79086 4 6 5.79086 6 8V57.062C6 59.2711 7.79086 61.062 10 61.062H48.05C50.2591 61.062 52.05 59.2711 52.05 57.062V8C52.05 5.79086 50.2591 4 48.05 4Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.002 11.133H40.326C39.5876 11.133 38.989 11.7316 38.989 12.47V12.471C38.989 13.2094 39.5876 13.808 40.326 13.808H43.002C43.7404 13.808 44.339 13.2094 44.339 12.471V12.47C44.339 11.7316 43.7404 11.133 43.002 11.133Z",
    fill: "#0CBABA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.04 50.05H14.51C13.6805 50.05 13.008 50.7222 13.008 51.5515C13.008 52.3808 13.6805 53.053 14.51 53.053H43.04C43.8695 53.053 44.542 52.3808 44.542 51.5515C44.542 50.7222 43.8695 50.05 43.04 50.05Z",
    fill: "#0CBABA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.04 25.023H14.51C13.6805 25.023 13.008 25.6952 13.008 26.5245C13.008 27.3538 13.6805 28.026 14.51 28.026H43.04C43.8695 28.026 44.542 27.3538 44.542 26.5245C44.542 25.6952 43.8695 25.023 43.04 25.023Z",
    fill: "#B6BABF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.04 18.015H14.51C13.6805 18.015 13.008 18.6872 13.008 19.5165C13.008 20.3458 13.6805 21.018 14.51 21.018H43.04C43.8695 21.018 44.542 20.3458 44.542 19.5165C44.542 18.6872 43.8695 18.015 43.04 18.015Z",
    fill: "#B6BABF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.026 31.029H14.51C13.6805 31.029 13.008 31.7012 13.008 32.5305C13.008 33.3598 13.6805 34.032 14.51 34.032H30.026C30.8555 34.032 31.528 33.3598 31.528 32.5305C31.528 31.7012 30.8555 31.029 30.026 31.029Z",
    fill: "#0CBABA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.042 43.543H14.51C13.6805 43.543 13.008 44.2152 13.008 45.0445C13.008 45.8738 13.6805 46.546 14.51 46.546H43.042C43.8715 46.546 44.544 45.8738 44.544 45.0445C44.544 44.2152 43.8715 43.543 43.042 43.543Z",
    fill: "#B6BABF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.04 37.036H14.51C13.6805 37.036 13.008 37.7082 13.008 38.5375C13.008 39.3668 13.6805 40.039 14.51 40.039H43.04C43.8695 40.039 44.542 39.3668 44.542 38.5375C44.542 37.7082 43.8695 37.036 43.04 37.036Z",
    fill: "#B6BABF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_542:15778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.507 31.789H33.025C30.8159 31.789 29.025 33.5799 29.025 35.789V115.126C29.025 117.335 30.8159 119.126 33.025 119.126H95.507C97.7161 119.126 99.507 117.335 99.507 115.126V35.789C99.507 33.5799 97.7161 31.789 95.507 31.789Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.447 42.706H41.989C40.8585 42.706 39.942 43.6225 39.942 44.753C39.942 45.8835 40.8585 46.8 41.989 46.8H47.447C48.5775 46.8 49.494 45.8835 49.494 44.753C49.494 43.6225 48.5775 42.706 47.447 42.706Z",
    fill: "#B6BABF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.657 42.706H67.917C66.7865 42.706 65.87 43.6225 65.87 44.753C65.87 45.8835 66.7865 46.8 67.917 46.8H85.657C86.7875 46.8 87.704 45.8835 87.704 44.753C87.704 43.6225 86.7875 42.706 85.657 42.706Z",
    fill: "#B6BABF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.718 102.271H42.049C40.7798 102.271 39.751 103.3 39.751 104.569V104.57C39.751 105.839 40.7798 106.868 42.049 106.868H85.718C86.9872 106.868 88.016 105.839 88.016 104.57V104.569C88.016 103.3 86.9872 102.271 85.718 102.271Z",
    fill: "#B6BABF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.635 64.54H41.989C40.8585 64.54 39.942 65.4565 39.942 66.587C39.942 67.7175 40.8585 68.634 41.989 68.634H55.635C56.7655 68.634 57.682 67.7175 57.682 66.587C57.682 65.4565 56.7655 64.54 55.635 64.54Z",
    fill: "#0CBABA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.718 53.24H42.049C40.7798 53.24 39.751 54.2688 39.751 55.538V55.539C39.751 56.8082 40.7798 57.837 42.049 57.837H85.718C86.9872 57.837 88.016 56.8082 88.016 55.539V55.538C88.016 54.2688 86.9872 53.24 85.718 53.24Z",
    fill: "#B6BABF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.72 73.159H42.049C40.7798 73.159 39.751 74.1879 39.751 75.457V75.458C39.751 76.7272 40.7798 77.756 42.049 77.756H85.72C86.9892 77.756 88.018 76.7272 88.018 75.458V75.457C88.018 74.1879 86.9892 73.159 85.72 73.159Z",
    fill: "#B6BABF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.095 92.312H61.345C60.0759 92.312 59.047 93.3409 59.047 94.61V94.611C59.047 95.8802 60.0759 96.909 61.345 96.909H85.095C86.3642 96.909 87.393 95.8802 87.393 94.611V94.61C87.393 93.3409 86.3642 92.312 85.095 92.312Z",
    fill: "#0CBABA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.718 82.352H42.049C40.7798 82.352 39.751 83.3809 39.751 84.65V84.651C39.751 85.9202 40.7798 86.949 42.049 86.949H85.718C86.9872 86.949 88.016 85.9202 88.016 84.651V84.65C88.016 83.3809 86.9872 82.352 85.718 82.352Z",
    fill: "#B6BABF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158.707 72.81L171.94 64.871L185.172 72.811L171.94 80.751L158.707 72.811V72.81Z",
    fill: "#969EA7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.94 63.328L187.744 72.811L171.94 82.294L156.135 72.811L171.94 63.328ZM161.279 72.811L171.94 79.207L182.6 72.811L171.94 66.414L161.279 72.811Z",
    fill: "#969EA7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.253 77.612L171.94 85.824L185.626 77.612L186.988 79.881L171.94 88.91L156.891 79.881L158.253 77.611V77.612Z",
    fill: "#969EA7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.253 84.228L171.94 92.44L185.626 84.228L186.988 86.498L171.94 95.526L156.891 86.497L158.253 84.228Z",
    fill: "#969EA7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_542:15778",
    x: 3.176,
    y: 93.689,
    width: 50.904,
    height: 60.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_542:15778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_542:15778",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_542:15778",
    x: 0,
    y: 0,
    width: 58.05,
    height: 69.062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_542:15778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_542:15778",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_542:15778",
    x: 23.025,
    y: 27.789,
    width: 82.482,
    height: 99.337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_542:15778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_542:15778",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyView);
export default __webpack_public_path__ + "static/media/empty-view.de80c90cd39e02b731161a5140de5840.svg";
export { ForwardRef as ReactComponent };